// Service approach for multiple components
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class BodyClassService {
	private bodyClassesSubject = new BehaviorSubject<string[]>([]);
	public bodyClasses$: Observable<string[]> = this.bodyClassesSubject.asObservable();
	private observer: MutationObserver | null = null;

	constructor() {
		this.initializeObserver();
	}

	private initializeObserver() {
		this.updateBodyClasses();

		this.observer = new MutationObserver(() => {
			this.updateBodyClasses();
		});

		this.observer.observe(document.body, {
			attributes: true,
			attributeFilter: ['class']
		});
	}

	private updateBodyClasses() {
		const classes = Array.from(document.body.classList);
		this.bodyClassesSubject.next(classes);
	}

	hasClass(className: string): Observable<boolean> {
		return new Observable((subscriber) => {
			const subscription = this.bodyClasses$.subscribe((classes) => {
				subscriber.next(classes.includes(className));
			});
			return () => subscription.unsubscribe();
		});
	}

	// Clean up method (call in app component OnDestroy)
	cleanup() {
		if (this.observer) {
			this.observer.disconnect();
		}
	}
}
